<template>
    <div id="app">
        <router-view></router-view>
        <!-- <Layout></Layout> -->
    </div>
</template>

<script>
import serverApi from "./server/index";
import Layout from "./pages/layout";
import { Storage } from "./utils/storage";
export default {
    name: "App",
    components: {
        Layout,
    },
    mounted() {
        window.$router = this.$router;

        // lang
        const language = navigator.language || navigator.userLanguage;
        const primaryLanguage = new Intl.Locale(language).language;
        const htmlElement = document.querySelector("html");
        if (htmlElement) {
            const _lang = localStorage.getItem("lang");
            if (_lang) {
                htmlElement.setAttribute("data-lang", _lang);
                this.$store.commit("setLang", _lang);
            } else {
                if (primaryLanguage === "en" || primaryLanguage === "zh") {
                    htmlElement.setAttribute("data-lang", primaryLanguage);
                    this.$store.commit("setLang", primaryLanguage);
                } else {
                    htmlElement.setAttribute("data-lang", "en");
                    this.$store.commit("setLang", "en");
                }
            }
        }

        // userInfo
        const storedUserInfo = Storage.getItem("user");
        if (storedUserInfo) {
            this.$store.commit("setUserInfo", JSON.parse(storedUserInfo));
        }

        // serverApi
        //     .renewToken()
        //     .then((res) => {
        //         console.log("renewToken success---->", res);
        //     })
        //     .catch((e) => {
        //         console.log("renewToken error---->", e);
        //     });
    },
};
</script>
